import {NEGATIVE_COLOR, PALETTE} from "@/statistics/utils/chartTheme";

const LABELS = {invoiced: 'Facturé HT', collected: 'Encaissé HT'};
const FIELDS = {invoiced: 'invoicedHt', collected: 'collectedHt'};

/**
 * Séries du graphique de chiffre d'affaires : le chiffre d'affaires choisi en barres, l'autre en courbe pointillée pour comparer.
 * series : lignes {invoicedHt, collectedHt} par période.
 */
export function revenueDatasets(series, metric) {
    const other = metric === 'invoiced' ? 'collected' : 'invoiced';
    return [
        {label: LABELS[metric], data: series.map(row => row[FIELDS[metric]]), color: PALETTE[0]},
        {label: LABELS[other], data: series.map(row => row[FIELDS[other]]), type: 'line', color: PALETTE[2], dashed: true},
    ];
}

export const revenueLabel = metric => LABELS[metric];

/** Couleur des soldes : le négatif (remboursements, retards) ressort */
export const signedColor = value => (value < 0 ? NEGATIVE_COLOR : PALETTE[0]);
